import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from 'src/utilities/activityTracker';

const RouteActivityTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackEvent({ type: 'route', route: location.pathname });
  }, [location]);

  return null;
};

export default RouteActivityTracker;
